import * as React from 'react'
// hooks
import { useModalData } from 'hooks/useShowModal'
// components
import { DrawerModal } from 'components/UI'
// view components
import ReviewResult from 'components/Modals/PlanItems/components/ReviewsList/components/ReviewResult'
// constants
import { Modals } from 'constants/index'

const PAPER_PROPS = {
  style: {
    top: '64px',
    left: '72px',
    height: 'calc(100% - 64px)',
    width: '414px',
    overflow: 'visible',
    zIndex: 1300
  }
}

const SidebarReviewDetailsModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, entity, review }
  } = useModalData({ modalType: Modals.SIDEBAR_REVIEW_DETAILS_MODAL })

  return (
    <DrawerModal width={'100%'} anchor={'left'} isOpen={isOpen} hideModal={hideModal} PaperProps={PAPER_PROPS}>
      <ReviewResult entity={entity} hideModal={hideModal} review={review} />
    </DrawerModal>
  )
}

export default SidebarReviewDetailsModal
